<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شيخه-الجويعد">
<h1><span dir="rtl">شيخه الجويعد</span></h1>
<p style="text-align: center;"><span dir="rtl">شيخه الجويعد حاصلة على ماجستير في التربية<br/>
عضو في المجلس الاستشاري لإمارة الشارقة<br/>
من 2019 – 2023.</span></p>
<p style="text-align: center;"><span dir="rtl">بدأت في الكتابة للطفل..</span></p>
<p style="text-align: center;"><span dir="rtl">وصدرت لها مجموعة من قصص الأطفال..</span></p>
<p style="text-align: center;"><span dir="rtl">كما شاركت في العديد من الجوائز..</span></p>
<p style="text-align: center;"><span dir="rtl">وصدرت لها روايتان "الخان في قلبي"، و"بوح القدر"</span></p>
<p style="text-align: center;"><span dir="rtl">حاصلة على العديد من الدورات في التنمية الذاتية.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?4a77a8b6